import {mapState, mapGetters, mapActions} from 'vuex'

export const campaignComputed = {
    ...mapGetters('campaign', ['isOfficialType', 'selectedTemplateType', 'templateTypeOptions']),
}

export const quotaComputed = {
    ...mapGetters('quota', ['subscriptionQuota']),
}

export const keywordComputed = {
    ...mapGetters('keyword', ['keywordList']),
}

export const layoutComputed = {
    ...mapState('layout', {
        layoutType: (state) => state.layoutType,
        leftSidebarType: (state) => state.leftSidebarType,
        layoutWidth: (state) => state.layoutWidth,
        topbar: (state) => state.topbar,
        loader: (state) => state.loader
    })
}

export const authMethods = mapActions('auth', ['logIn', 'logOut', 'register', 'resetPassword'])

export const layoutMethods = mapActions('layout', ['changeLayoutType', 'changeLayoutWidth', 'changeLeftSidebarType', 'changeTopbar', 'changeLoaderValue'])

export const notificationMethods = mapActions('notifications', ['addNotification', 'clearNotifications', 'getNotifications'])

export const campaignMethods = mapActions('campaign', ['setTemplateType'])

export const quotaMethods = mapActions('quota', ['getSubscriptionQuota'])

export const keywordMethods = mapActions('keyword', ['addKeyword', 'removeKeyword', 'clearKeywords'])

